import React, { createContext, useState, useEffect } from "react"
import { useApp } from "@inlet/react-pixi"
import { Texture } from "pixi.js"
import { spritesheets } from "global.js"

export const TextureContext = createContext({})

export const TextureProvider = ({ children }) => {
  const [state, setState] = useState({})
  const app = useApp()
  useEffect(() => {
    spritesheets
      .reduce((a, c) => a.add(c), app.loader)
      .load((_, resource) => {
        spritesheets.map(spritesheet =>
          setState(prev => ({
            ...prev,
            [spritesheet]: Object.keys(resource[spritesheet].data.frames).map(
              frame => Texture.from(frame)
            ),
            counter: (prev.counter || 0) + 1,
            loaded: (prev.counter || 0) + 1 === spritesheets.length,
          }))
        )
      })
  }, [])

  return (
    <TextureContext.Provider value={state}>
      {state.loaded ? children : <></>}
    </TextureContext.Provider>
  )
}
